import React, { useState } from "react";
import { Tooltip } from "antd";
import { getStaffStatusColor } from "../utils/Common";
import { constants } from "../constant/constants";

function StaffItemComponent({ record, callback }) {
  let color = getStaffStatusColor(record.status);
  let dot = { background: color };
  let dotText = { color };

  const [statusMap, setStatusMap] = useState({ on: "Active", off: "Inactive" });

  const changeBranch = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.CHANGE);
  };

  const viewStaff = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.VIEW);
  };

  const editStaff = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.EDIT);
  };

  const onStaff = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.ON);
  };

  const offStaff = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.OFF);
  };

  const deleteStaff = (e) => {
    e.stopPropagation(); // Prevent parent click event
    callback(record, constants.STAFF.DELETE);
  };

  return (
    <div
      onClick={viewStaff}
      className="grid w-full grid-cols-[auto,1fr,auto,auto,auto] items-stretch mb-3 px-5 bg-white rounded"
    >
      <div className="px-2 py-1 flex items-center pr-10">
        <img className="w-[48px] h-[48px]" src={"/images/tabletap.svg"} />
      </div>

      <div className="px-2 py-1 overflow-hidden">
        <div className="font-ubold break-words line-clamp-2">{record.name}</div>
        <div>{record.position}</div>
        <div className="flex items-center">
          {record.address && <img className="w-[15px] h-[15px] mr-[4px] cursor-pointer" src={"/images/icons/location.svg"} />}
          <span className="break-words line-clamp-1 text-[13px] ">
            {record.address && (
              <Tooltip placement="top" title={record.address}>
                {record.address}
              </Tooltip>
            )}
          </span>
        </div>
      </div>

      <div className="px-5 py-1 flex items-center">
        <div className="grid grid-cols-[7rem,auto,5rem] gap-y-1 w-full">
          {/* Contact row */}
          <span>Contact</span>
          <span>: {record.contact}</span>
          <div /> {/* empty 3rd column */}
          {/* Emergency Contact row */}
          <span className="text-sm">Emerg. Contact</span>
          <span className="text-sm">
            : {record.econ !== "" && !record.econ?.startsWith("0") ? `0${record.econ}` : record.econ || ""}
          </span>
          <div className="truncate ml-1.5 text-sm">
            {record.econ_name && (
              <Tooltip placement="right" title={record.econ_name}>
                ({record.econ_name})
              </Tooltip>
            )}
          </div>
        </div>
      </div>

      <div className="pl-10 pr-[100px] py-1 flex items-center">
        <div style={dot} className="w-[12px] h-[12px] rounded-[6px]" />
        <div style={dotText} className="text-md ml-[8px]">
          {statusMap[record.status.toLowerCase()]}
        </div>
      </div>

      <div className="px-2 py-1 flex items-center gap-2">
        <Tooltip placement="bottom" title="Change Branch">
          <img
            onClick={(e) => changeBranch(e)} // Pass event to prevent propagation
            className="w-[30px] h-[30px] mr-[2px] cursor-pointer"
            src={"/images/changeBranchIcon.svg"}
          />
        </Tooltip>

        <Tooltip placement="bottom" title="Edit Staff">
          <img
            onClick={(e) => editStaff(e)} // Pass event to prevent propagation
            className="w-[30px] h-[30px] cursor-pointer"
            src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/edit_user_icon.svg"}
          />
        </Tooltip>
        <Tooltip
          onClick={(e) => {
            e.stopPropagation();
            if (record.status.toLowerCase() === "on") {
              offStaff(e);   // turn OFF
            } else {
              onStaff(e);    // turn ON
            }
          }}
          placement="bottom"
          title={`${record.status.toLowerCase() === "on" ? "Inactive" : "Active"}`}
        >
          <img
            className="w-[36px] h-[36px] cursor-pointer"
            src={record.status.toLowerCase() === "on" ? "/images/tickicongrey.svg" : "/images/tickicon.svg"}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default StaffItemComponent;
